export function anchorlink (){
  $(function(){

    const innerLink = document.querySelectorAll('.innerLink');
    let off = 78;
    // if (window.innerWidth < 769){
    //   let off = window.innerHeight * 8 / 100;
    // }
    // let option = 0;
    // if(document.querySelector('.featurePage')){
    //   option = 66;
    //   if (window.innerWidth < 769){
    //     option = 112;
    //   }
    // }

    if(!($('.page-top').length)){
      const urlHash = location.hash;
      if(urlHash){
        const hash = document.querySelector(urlHash);
        $('html,body').stop().scrollTop(0);
        let position = hash.getBoundingClientRect().top + window.pageYOffset - off;
        $('html,body').animate({scrollTop:position},1000);//引数topの値までスクロールさせる
        return false;
      }
    }


    [...innerLink].forEach(link => {
      link.addEventListener('click', ()=>{
        let anchor = document.querySelector(link.getAttribute('href'));
        let position = anchor.getBoundingClientRect().top + window.pageYOffset - off;
        $('html,body').animate({scrollTop:position},1000);//引数topの値までスクロールさせる
        return false;
      });
    });
  });
}
